module.exports = __webpack_public_path__ + "static/media/toggle-open.1967b758.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/toggle-open.svg
// module id = 657
// module chunks = 0